import Loadable from 'react-loadable';

export const Modals = Loadable({
  loader: () => import(/* webpackChunkName: "AtlasModals" */ './Modals'),
  loading: () => null,
});
